import { editor } from 'monaco-editor';

export const editorOptions: editor.IStandaloneEditorConstructionOptions = {
    minimap: {
        maxColumn: 80,
        enabled: false
    },
    scrollbar: {
        horizontalScrollbarSize: 6,
        verticalScrollbarSize: 6
    },
    wordWrap: 'on',
    domReadOnly: false,
    selectOnLineNumbers: true,
    mouseStyle: 'text',

    automaticLayout: true
};
